import { FC } from 'react';
import { AppMenuProps } from './types';
import { useStyles } from './styles';
import clsx from 'clsx';
import {
  CssBaseline,
  Drawer,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  Grid,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { MainItems } from './NavBarItems';
import ProfileMenu from './ProfileMenu/ProfileMenu';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { ReactComponent as LogoIcon } from 'assets/logo.svg';
import { useStore } from 'hooks/useRootStore';
import { observer } from 'mobx-react-lite';
// import { version } from '../../../package.json';

const AppMenu: FC<AppMenuProps> = observer(({ title, additionalDescription = '' }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    appMenuStore: { isOpen, openAppMenu, closeAppMenu },
  } = useStore();
  const handleToggleMenu = () => {
    if (isOpen) {
      closeAppMenu();
    } else {
      openAppMenu();
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      <CssBaseline />
      <header className={clsx(classes.appBar, { [classes.appBarShift]: isOpen })}>
        <Toolbar style={{ paddingLeft: 16 }}>
          <IconButton
            style={{ marginRight: 20 }}
            edge='start'
            color='inherit'
            onClick={handleToggleMenu}
            className={isOpen ? classes.menuButtonHidden : ''}
          >
            <MenuIcon />
          </IconButton>
          <Typography component='h1' variant='h6' color='inherit' noWrap className={classes.title}>
            {title}
            {additionalDescription && ` ${additionalDescription}`}
          </Typography>
          <ProfileMenu />
        </Toolbar>
      </header>
      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: isOpen,
          [classes.drawerClose]: !isOpen,
          [classes.drawerMobile]: isMobile,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: isOpen && !isMobile,
            [classes.drawerClose]: !isOpen && !isMobile,
            [classes.drawerMobile]: isMobile,
          }),
        }}
        open={isOpen}
        onClose={isMobile ? closeAppMenu : undefined}
        ModalProps={
          isMobile
            ? {
                keepMounted: true,
              }
            : undefined
        }
      >
        <Grid container justify='space-between' className={classes.toolbarHead} alignItems='center'>
          <LogoIcon style={{ width: isMobile ? '120px' : '140px', height: isMobile ? '45px' : '52px' }} />
          <IconButton className={classes.toolbarIcon} onClick={handleToggleMenu}>
            <ChevronLeftIcon />
          </IconButton>
        </Grid>
        <Divider />
        <div className={classes.navBar}>
          <List>
            <MainItems />
          </List>
          {/* <div className={classes.version}>v{version}</div> */}
        </div>
      </Drawer>
    </div>
  );
});

export default AppMenu;
